module.exports = __webpack_public_path__ + "img/3.3aa4e7a3.jpg";